// Mail.ru, bk.ru and Yandex drop Firebase's password-reset email, so the server sends those itself
// (exsportia-server#3913; react-native-booking-app#668). `sent: false`, any failure, or a 404 from a
// server without the route leaves the reset to Firebase; only the server's own "no such account"
// answer stops it.
type Post = (url: string, body: {email: string}) => Promise<{data?: {sent?: boolean}}>

export const FORGOT_PASSWORD_URL = 'user/forgot-password'

export class NoAccountError extends Error {
  code = 'auth/user-not-found'
}

export const sentByServer = async (post: Post, email: string): Promise<boolean> => {
  try {
    const res = await post(FORGOT_PASSWORD_URL, {email})
    return res.data?.sent === true
  } catch (error: unknown) {
    const code = (error as {response?: {data?: {code?: string}}}).response?.data?.code
    if (code === 'auth/user-not-found') {
      throw new NoAccountError('There is no user with this email.')
    }
    return false
  }
}
